import { createNextTableContext } from '@core/table';

export const DeclarationTableContext = createNextTableContext();
